export enum TransactionCode {
    FinancialAidPayment = 11,
    StudentPaymentPlan = 12,
    MiscStudentPayment = 13,
    RefundToStudent = 16,
    TerminationFee = 23,
    FinancialAidRefund = 22,
}
